export default class InvoiceDisputeHelper {
	/**
	 *
	 * @param due
	 */
	static isDue(due) {
		const todayDate = new Date();
		const dueDate = new Date(due);
		return dueDate < todayDate;
	}

	/**
	 *
	 * @param until
	 */
	static isOverDue(until) {
		const todayDate = new Date();
		const untilDate = new Date(until);
		return untilDate <= todayDate;
	}
}
